module.exports = __webpack_public_path__ + "img/anxiety.f01c3963.svg";